// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"quickPricer_spinnerWrapper__33yRy","spinner":"quickPricer_spinner__x3W4B"};